import { TMostPlayTicketResponse } from "@api-types/bet-booster/MostPlayedTicketsResponse";
import { GenericResponse } from "@api-types/common";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

export class QuickPlayApiService {
	static get baseUrl() {
		return `${WEBPACK_BET_BOOSTER_API_ADDRESS}/quick-play`;
	}

	static getRequestHeaders = (
		context: ApiRequestContextData | null = getApiRequestContext()
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static getMostPlayedPicksAvailability(): Promise<
		GenericResponse<TMostPlayTicketResponse[]>
	> {
		return httpClient.get(
			`${this.baseUrl}/bet-slips?sort=submitCount&isAscending=false`,
			this.getRequestHeaders()
		);
	}
}
